import { CompanyInfoContext } from "../../App";
import { useContext, useEffect } from "react";
import { extractErrorMessages } from "./ExtractErrorMsg";
import { useToast } from "../../hooks/otherHooks/useToast";
import ScrollToTop from "../../utils/scrollToTop";
import Brand from "../../components/common/Brand";
import { useState } from "react";

//npm install --save redux @redux-devtools/extension react-redux redux-thunk @reduxjs/toolkit

// Utility function to extract error messages

const carouselImages = [
  "https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Fwallpaperaccess.com%2Ffull%2F2221274.jpg&f=1&nofb=1",
  "https://images.unsplash.com/photo-1464822759023-fed622ff2c3b?auto=format&fit=crop&q=80&w=2000",
  "https://images.unsplash.com/photo-1507525428034-b723cf961d3e?auto=format&fit=crop&q=80&w=2000"
];

const AuthUITemplate = ({ children, errorMsg, title }) => {
  const companyInfo = useContext(CompanyInfoContext);
  const { addToast } = useToast();
  const [currentImgIndex, setCurrentImgIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentImgIndex((prev) => (prev + 1) % carouselImages.length);
    }, 8000);
    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    if (errorMsg) {
      const extractedMessages = extractErrorMessages(errorMsg);
      extractedMessages.map((message) =>
        addToast({
          message: message,
          bg: "danger",
        })
      );
    }
  }, [errorMsg, addToast]);

  return (
    <main className="cht-relative cht-w-full cht-min-h-screen cht-overflow-y-auto cht-bg-black">
      <ScrollToTop />
      
      {/* Fixed Background Carousel */}
      <div className="cht-fixed cht-inset-0 cht-z-0">
        {carouselImages.map((img, index) => (
          <div
            key={img}
            className={`cht-absolute cht-inset-0 cht-transition-opacity cht-duration-[2000ms] cht-ease-in-out ${
              index === currentImgIndex ? "cht-opacity-100" : "cht-opacity-0"
            }`}
            style={{
              backgroundImage: `url(${img})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
          />
        ))}
        {/* Dark Overlay */}
        <div className="cht-absolute cht-inset-0 cht-bg-black/40 cht-backdrop-blur-[2px] cht-z-0" />
      </div>

      <section className="cht-relative cht-z-10 cht-min-h-screen cht-w-full cht-flex cht-items-center cht-py-12 md:cht-py-20">
        <div className="cht-container cht-mx-auto cht-px-6 md:cht-px-12 cht-grid cht-grid-cols-1 lg:cht-grid-cols-2 cht-gap-12 cht-items-center">
          
          {/* Left Side: Branding Content */}
          <div className="cht-hidden lg:cht-block cht-text-white cht-space-y-8 cht-animate-in cht-slide-in-from-left-10 cht-duration-1000">
            <Brand to="/" theme="light" size="lg" />
            
            <div className="cht-space-y-4">
              <h1 className="cht-text-7xl cht-font-black cht-tracking-tighter cht-uppercase leading-[0.9]">
                Explore <br />
                <span className="cht-text-transparent cht-bg-clip-text cht-bg-gradient-to-r cht-from-white cht-to-white/50">Horizons</span>
              </h1>
              <div className="cht-h-1 cht-w-24 cht-bg-white/40 cht-rounded-full"></div>
            </div>

            <div className="cht-space-y-4 cht-max-w-md">
              <p className="cht-text-2xl cht-font-bold cht-leading-tight">Where Your Dream Destinations Become Reality.</p>
              <p className="cht-text-white/70 cht-font-medium cht-text-lg leading-relaxed">
                Embark on a journey where every corner of the world is within your reach.
              </p>
            </div>
          </div>

          {/* Right Side: Auth Card */}
          <div className="cht-flex cht-justify-center lg:cht-justify-end cht-animate-in cht-fade-in cht-zoom-in-95 cht-duration-1000">
            <div className="cht-w-full cht-max-w-[480px] cht-bg-white/10 cht-backdrop-blur-3xl cht-border cht-border-white/20 cht-rounded-[40px] cht-p-8 md:cht-p-12 cht-shadow-[0_20px_50px_rgba(0,0,0,0.3)]">
              {/* Mobile-only Brand Header */}
              <div className="lg:cht-hidden cht-mb-6 cht-flex cht-justify-center">
                <Brand to="/" theme="light" size="md" />
              </div>

              <header className="cht-mb-8">
                <h2 className="cht-text-2xl cht-font-black cht-text-white cht-tracking-tight">{title}</h2>
                <div className="cht-h-1 cht-w-8 cht-bg-white/20 cht-rounded-full cht-mt-2"></div>
              </header>

              <div className="auth-form-container">
                {children}
              </div>
            </div>
          </div>

        </div>
      </section>

      {/* Decorative Blur Circle */}
      <div className="cht-absolute -cht-top-40 -cht-left-40 cht-w-96 cht-h-96 cht-bg-blue-500/20 cht-rounded-full cht-blur-[120px] cht-z-0"></div>
    </main>
  );
};

export default AuthUITemplate;

